<template>
    <Modal class="menu-modal"
           :cancel="close"
           :icon="modalIcon"
           cancel-label="CLOSE">
        <template v-slot:header-title>
            <template v-if="currentUser">
                {{ l('LOGGED_IN_AS') }} <strong>{{ currentUser.username }}</strong>
            </template>
            <template v-else>
                {{ l('NOT_LOGGED_IN') }}
            </template>
        </template>

        <!-- Order branch switcher, for desktop only -->
        <div v-if="showBranchSelector"
             class="menu-btns menu-btns--grey desktop-only">
            <OrderBranchSelector :show-label="true"
                                 btn-classes="btn btn-white" />
        </div>

        <!-- Online status and order branch switcher, for mobile only -->
        <div class="menu-btns menu-btns--grey mobile-only">
            <MenuBarClock v-if="showClock" />

            <NavOnlineBtn v-if="showConnectivity"
                          online-class="btn-success"
                          offline-class="btn-danger" />

            <ProPointUpdate v-if="showUpdate" />

            <OrderBranchSelector v-if="showBranchSelector"
                                 btn-classes="btn btn-dark-blue" />
        </div>

        <div class="menu-btns menu-btns--grid-desktop">
            <slot name="buttons"></slot>
        </div>

        <div class="menu-btns menu-btns--grey menu-btns--grid-desktop">
            <slot name="bottom-buttons"></slot>
        </div>

        <h6 v-if="eposVersionCurrent?.commit"
            class="ma-0 pb-1 menu-btns--grey text-center text-muted">
            {{ l('VERSION') }}: {{ eposVersionCurrent.commit }}
        </h6>
    </Modal>
</template>

<script>
import MenuBarClock from '@/vue/components/Menus/MenuBarClock';
import Modal from '@/vue/components/Modals/Modal';
import NavOnlineBtn from '@/vue/components/Menus/NavOnlineBtn';
import OrderBranchSelector from '@/vue/components/Branches/OrderBranchSelector';
import ProPointUpdate from '@/vue/components/Menus/ProPointUpdate';
import { mapState } from 'vuex';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'AbstractMenuModal',

    components: {
        Modal,
        OrderBranchSelector,
        MenuBarClock,
        NavOnlineBtn,
        ProPointUpdate,
    },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        showClock: {
            type: Boolean,
            default: true,
        },

        showBranchSelector: {
            type: Boolean,
            default: true,
        },

        showConnectivity: {
            type: Boolean,
            default: true,
        },

        showUpdate: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        ...mapState([
            'eposVersionCurrent',
            'currentUser',
        ]),

        modalIcon() {
            return this.currentUser ? 'fa-user' : 'fa-user-slash';
        },
    },

    methods: {
        close() {
            this.resolve();
        },
    },
};
</script>

<style lang="less">
@import "../../../less/variables";

.menu-modal {
    .modl-body {
        border-radius: 5px 5px 0 0;

        // Padding is added to the .menu-btns sections instead so we can have a background going right to the edge.
        padding: 0;
    }
}

.menu-btns {
    background: @modal-body-bg--grey;
    padding: @gutter-width;

    // On mobile the buttons in the menu use a grid layout with only one column.
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-column-gap: @half-gutter-width;
    grid-row-gap: @half-gutter-width;

    .btn {
        height: 46px;
        display: flex;
        line-height: normal;
        align-items: center;
        justify-content: flex-start;
        font-weight: bold;
    }
}

.menu-btns--grey {
    background: @model-body-bg--grey-alt;
}

@media (max-width: @mobile-max) {
    .menu-btns {
        .btn {
            i {
                font-size: 17px;
                margin-right: 10px !important;
            }
        }
    }
}

@media (min-width: @non-mobile-min) {
    // On desktop the grid increases to 3 columns so the buttons look like big squares instead of rectangles.
    .menu-btns {
        &--grid-desktop {
            padding: @gutter-width;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: @gutter-width;
            grid-row-gap: @gutter-width;

            .btn {
                flex-direction: column;
                height: 92px;
                justify-content: center;

                i {
                    font-size: 26px;
                    margin-bottom: 10px;
                }
            }
        }
    }

    .menu-modal {
        .order-branch-selector {
            .dropmenu {
                left: 6px;
            }
        }
    }
}

</style>
